<template>
  <div v-if="!$route.meta.hideNavbar">
    <nav-bar/>
      <router-view class="mt-5"/>
  </div>
  <div v-else>
    <router-view class="mt-5"/>
  </div>
  <ModalRenewSignature :visibleModalSignatureRequired="isModalSignatureRequiredOpen"
                          @close="closeModalSignatureRequiredVerify"></ModalRenewSignature>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;400&display=swap');
</style>

<script>
import ModalRenewSignature from "@/components/ModalRenewSignature.vue";
import NavBar from "@/components/Navbar.vue";
import {mapGetters} from "vuex";
import {mapActions} from 'vuex';
export default {
  name: 'App',
  components: {
    NavBar,
    ModalRenewSignature
  },
  computed: {
    ...mapGetters({User: "StateUser"}),
    ...mapGetters(['isModalSignatureRequiredOpen']),
  },
  setup() {
  },
  data() {
    return {
      isModalSignatureRequiredVisible: false,
      modalInterval: null,
    };
  },
  mounted() {
    this.modalInterval = setInterval(() => {
      this.openModalSignatureRequiredVerify();
    }, 180000);

  },
  beforeUnmount() {
    clearInterval(this.modalInterval);
  },
  created() {

  },
  methods: {
    ...mapActions(['closeModalSignatureRequired']),
    ...mapActions(['openModalSignatureRequired']),
    async closeModalSignatureRequiredVerify() {
      await this.closeModalSignatureRequired()
      this.modalInterval = setInterval(() => {
        this.openModalSignatureRequiredVerify();
      }, 180000);
    },
    async openModalSignatureRequiredVerify() {
      const dateActual = new Date();
      if (this.User.user_cess_access_info != null) {
        const dateExpired = new Date(this.User.user_cess_access_info.expired_at);
        if (dateActual > dateExpired) {
          await this.openModalSignatureRequired()
          clearInterval(this.modalInterval);
        }
      }
    }
  }
}
</script>